// removed by extract-text-webpack-plugin
module.exports = {"base":"Reward_base--2SKmW","perBattleReward":"Reward_perBattleReward--1lmS5","sign":"Reward_sign--2_uHb","value":"Reward_value--3chV2","value__bonus":"Reward_value__bonus--1KY1p","valueBonus":"Reward_value__bonus--1KY1p"};


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Reward/Reward.scss
// module id = 505
// module chunks = 11 12